export const FieldNames = {
  upperLimit: 'upperLimit',
  lowerLimit: 'lowerLimit',
  actual: 'actual',
  notes: 'notes',
  status: 'status'
};
